import { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Select,
  Form,
  Popconfirm,
  Input,
  Alert,
  Tag,
} from "antd";

import { contribEnum } from "@seims/shared";
import lookupApi from "../../../services/partnershipLookupService";
import { recordError } from "../../../utils/logService";

const ContributeModal = ({
  onShow,
  previewOrgsContrib,
  show,
  setOrgsContributions,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [contributions, setContributions] = useState([]);
  const [showOther, setShowOther] = useState(false);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    getContributions();
  }, [previewOrgsContrib, show]);

  useEffect(() => {
    loadRecord();
  }, [previewOrgsContrib?.contributions, show, setOrgsContributions]);

  const { Option } = Select;
  const [form] = Form.useForm();
  const formName = "AddContributions";

  const Confirm = () => {
    form.resetFields();
    onShow(false);
    setDisabled(true);
    setShowOther(false);
  };

  const loadRecord = () => {
    let matchedContributions = [];
    setShowOther(false);

    if (previewOrgsContrib?.contributions !== undefined) {
      matchedContributions = previewOrgsContrib?.contributions?.map(
        (c) => c.value
      );

      if (
        previewOrgsContrib?.contributions?.find(
          (c) => c.label == contribEnum.OTHER || c.value == contribEnum.OTHER
        )
      ) {
        setShowOther(true);
      } else {
        setShowOther(false);
      }
    }

    form.setFieldsValue({
      name: previewOrgsContrib.name,
      type: previewOrgsContrib.type,
      contributions: matchedContributions,
      other: previewOrgsContrib.otherContribution,
    });
    setSelected(matchedContributions);
  };

  const getContributions = async () => {
    try {
      const response = await lookupApi.getContributions();
      if (response) {
        const { data } = response;
        const transformData = data.map((c) => ({
          label: c.value,
          value: c.key.toString(),
          key: c.key,
        }));

        setContributions(transformData);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const AssociateContribution = async () => {
    const selectedValues = form.getFieldValue("contributions");

    const typeObject = selectedValues.map((c) => c.key);
    var contributionItems = [];

    if (typeObject[0] === undefined) {
      contributionItems = contributions.filter((item) =>
        selectedValues.includes(item.value)
      );
    } else {
      contributionItems = [...selectedValues];
    }
    const otherContribution = form.getFieldValue("other");

    const contibutionsObj = {
      contributions: contributionItems,
      otherContribution: otherContribution,
      id: previewOrgsContrib.id,
      name: previewOrgsContrib.name,
      type: previewOrgsContrib.type,
      typeid: previewOrgsContrib.typeid,
      address: previewOrgsContrib.address,
      email: previewOrgsContrib.email,
      telephone: previewOrgsContrib.telephone,
    };

    setOrgsContributions(contibutionsObj);

    onShow(false);
  };

  const handleCancel = () => {
    onShow(false);
  };

  const onContributeSelection = (selectedValue) => {
    form.setFieldsValue({ contributions: selectedValue });
    let updateIncludesOther;

    setSelected(selectedValue);

    if (Array.isArray(selectedValue)) {
      updateIncludesOther = selectedValue?.find(
        (c) => c.label === contribEnum.OTHER
      );
    } else {
      updateIncludesOther = selectedValue?.label === contribEnum.OTHER;
    }

    if (updateIncludesOther) {
      setShowOther(true);
    } else {
      setShowOther(false);
      form.setFieldsValue({
        other: "",
      });
    }
  };

  const atLeastOneSelected = () => ({
    validator(_, value) {
      const selectedValues = form.getFieldValue("contributions");

      const expectedContributions = ["Funding", "Host Organization"];

      if (selectedValues.length === 0) {
        return Promise.reject(
          new Error("Please select at least one contribution")
        );
      }

      selectedValues?.forEach((contrib) => {
        if (!expectedContributions.includes(contrib)) {
          try {
            Promise.reject(
              new Error(
                "Selected contributions should include Host Organization or Funding"
              )
            );
          } catch (error) {}
          // openNotification("Contributions",'Please selected at least Funding or Host Organization as a contributor', Notify.ERROR);
        } else {
          return Promise.resolve();
        }
      });
    },
  });

  return (
    <>
      <Modal
        forceRender
        // title="Add/Update Contributions"
        title="Partner Contributions"
        open={show}
        closable={false}
        keyboard={false}
        maskClosable={false}
        centered
        footer={[
          <div className="modal-footer-buttons">
            <Popconfirm
              key="cancel"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => Confirm()}
              onCancel={handleCancel}
              disabled={disabled}
            >
              <Button
                onMouseUp={() => handleCancel()}
                style={{ marginLeft: 10 }}
              >
                Cancel
              </Button>
            </Popconfirm>
            <Button
              key="update"
              type="primary"
              htmlType="submit"
              onClick={AssociateContribution}
              form={formName}
            >
              Update
            </Button>
          </div>,
        ]}
      >
        <p>
          How does partner <b>{previewOrgsContrib.name}</b> contribute to your
          project?
        </p>
        <br />
        <Form
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          name={formName}
          onFinish={AssociateContribution}
        >
          {/* <Form.Item name="name" label="Organization Name" >
            <Input name="name" readOnly />
          </Form.Item>
          <Form.Item name="type" label="Organization Type">
            <Input name="type" readOnly />
          </Form.Item> */}
          <Form.Item
            name="contributions"
            label="Contributions"
            rules={[
              {
                required: true,
                message: "Please select at least 1 contribution type",
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              placeholder="Please select"
              onSelect={onContributeSelection}
              onChange={onContributeSelection}
              value={selected}
              defaultValue={selected}
              labelInValue
            >
              {contributions.map((contribute) => (
                <Option key={contribute.value} value={contribute.value}>
                  {contribute.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {showOther && (
            <Form.Item
              name="other"
              label="Other Contributions"
              rules={[
                {
                  required: true,
                  message: "Please provide other contributions",
                },
              ]}
            >
              <Input />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </>
  );
};
export default ContributeModal;
